__webpack_require__.p = "https://ikea.marat.qd.je/at/en/customer-service/support/";